import React from 'react';
import './CarouselCreditCardOffer.scss';

const AnnualFee = ({annualFeeDetails}) => {
    
    return (
      <div className="annualFeeBlock">
        <div className="annualFeeTitle" data-testid="annualFeeLabel">
          Annual Fee
        </div>
        <div className="annualFee" data-testid="annualFee">
          {annualFeeDetails}
        </div>
      </div>
    );
  };

export default AnnualFee;
  